import React, { Fragment } from "react";
import { connect } from "react-redux";
import ShowTimeslot from "../components/ShowTimeslot";
import EditTimeslot from "../components/EditTimeslot";
import { requestTimeslot } from "../actions/timeslotAction";
import Spinner from "../components/layout/Spinner";
import Tab from "react-bootstrap/Tab";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";

class TimeslotContainer extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props.requestTimeslot(this.props.match.params.id);
  }
  render() {
    const { loading, timeslot } = this.props;
    return (
      <Fragment>
        {loading ? (
          <Spinner />
        ) : (
          <Tab.Container
            mountOnEnter
            unmountOnExit
            id="left-tabs-example"
            defaultActiveKey="show"
          >
            <Row>
              <Col sm={2} className="pt-5">
                <Nav variant="tabs" className="flex-column">
                  <Nav.Item>
                    <Nav.Link eventKey="show">Show Timeslot</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="edit">Edit Timeslot</Nav.Link>
                  </Nav.Item>
                </Nav>
              </Col>
              <Col sm={10}>
                <div className="container-fluid">
                  <Tab.Content>
                    <Tab.Pane eventKey="show">
                      <ShowTimeslot timeslot={timeslot} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="edit">
                      <EditTimeslot timeslot={timeslot} />
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </Col>
            </Row>
          </Tab.Container>
        )}
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  timeslot: state.requestTimeslot.timeslot,
  loading: state.requestTimeslot.loading,
});
const mapDispatchToProps = (dispatch) => ({
  requestTimeslot: (timeslotId) => dispatch(requestTimeslot(timeslotId)),
});
export default connect(mapStateToProps, mapDispatchToProps)(TimeslotContainer);
